/* eslint-disable max-len */
import React from 'react';

const FailureIcon = (
  <svg
    width="85px"
    height="82px"
    viewBox="0 0 85 82"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <title>icon / form / failure@1.5x</title>
    <defs>
      <path
        d="M18.1922576,20.4412352 L10.1679739,28.5069523 C10.0915652,28.5786506 10.0150806,28.6458535 9.92745313,28.7036084 C9.75416899,28.817899 9.55776514,28.8956928 9.35355365,28.9311229 C9.26281826,28.9468188 9.23947114,28.9460569 9.14775031,28.952381 L9.04420432,28.952381 C8.9524835,28.9460569 8.92913638,28.9468188 8.83840098,28.9311229 C8.66822474,28.9016359 8.50343046,28.8427382 8.35296282,28.7577059 C8.23258872,28.6896649 8.1216141,28.6050899 8.02398069,28.5069523 C7.7291096,28.2105587 7.5665894,27.7962171 7.58076443,27.3773801 C7.58553998,27.2386313 7.60919031,27.1007206 7.6509574,26.9683721 C7.70318521,26.8030317 7.78368729,26.6469107 7.8879913,26.5086191 C7.94363021,26.4348635 7.96121635,26.4193962 8.02398069,26.3518886 L16.0481885,18.2861714 L8.02398069,10.2204543 C7.96121635,10.1528705 7.94363021,10.1374794 7.8879913,10.0636476 C7.78368729,9.92543218 7.70318521,9.7693112 7.6509574,9.60389459 C7.58826886,9.4053337 7.5666652,9.19427703 7.58788985,8.98703006 C7.6414821,8.46266473 7.97122226,7.9930827 8.44483525,7.76671109 C8.5695301,7.70712758 8.70225999,7.66476386 8.83840098,7.6411438 C9.00850142,7.61173302 9.18345321,7.61173302 9.35355365,7.6411438 C9.59187619,7.68251701 9.8192832,7.78172126 10.0119727,7.92869899 C10.0854252,7.98462519 10.1007373,8.00230214 10.1679739,8.06539056 L18.1922576,16.1310315 L26.2165412,8.06539056 C26.2837021,8.00230214 26.2990899,7.98462519 26.3724666,7.92869899 C26.5100478,7.8238564 26.6653668,7.74293864 26.8298579,7.69044115 C27.0273988,7.62742893 27.237447,7.60571371 27.4435536,7.62704796 C27.6152459,7.64472491 27.7837545,7.69219361 27.9396041,7.76671109 C28.0642989,7.8262946 28.1808071,7.90309789 28.2848837,7.9943018 C28.6801171,8.34075474 28.8715938,8.88233986 28.782526,9.40182879 C28.7414412,9.64138191 28.6426707,9.86996313 28.4965238,10.0636476 C28.4408849,10.1374794 28.4232988,10.1528705 28.3605344,10.2204543 L20.3362508,18.2861714 L28.3605344,26.3518886 C28.4232988,26.4193962 28.4408849,26.4348635 28.4965238,26.5086191 C28.6008279,26.6469107 28.6813299,26.8030317 28.7335577,26.9683721 C28.7753248,27.1007206 28.7989752,27.2386313 28.8036749,27.3773801 C28.8179257,27.7962171 28.6553297,28.2105587 28.3605344,28.5069523 C28.262901,28.6050899 28.1519264,28.6896649 28.0315523,28.7577059 C27.8810847,28.8427382 27.7162146,28.9016359 27.5461142,28.9311229 C27.4553788,28.9468188 27.4320316,28.9460569 27.3403108,28.952381 L27.2367648,28.952381 C27.145044,28.9460569 27.1216969,28.9468188 27.0309615,28.9311229 C26.82675,28.8956928 26.6303461,28.817899 26.457062,28.7036084 C26.3693587,28.6458535 26.2928741,28.5786506 26.2165412,28.5069523 L18.1922576,20.4412352 Z"
        id="path-1"
      ></path>
    </defs>
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="02_DCT_Long_Page_desk"
        transform="translate(-396.000000, -4743.000000)"
      >
        <g id="13.-Newsletter" transform="translate(0.000000, 3296.000000)">
          <g id="Fail" transform="translate(116.000000, 1128.000000)">
            <g id="ICON-AND-COPY" transform="translate(184.000000, 320.000000)">
              <g id="Failer-icon" transform="translate(97.000000, 0.000000)">
                <g id="icon-/-form-/-failure">
                  <path
                    d="M41.5,0 C18.6353043,0 -7.10542736e-15,16.1436364 -7.10542736e-15,36.3563636 C-7.10542736e-15,48.0818182 6.37115217,58.2963636 16.1687609,64.9636364 C16.1543261,65.3545455 16.1831957,65.9945455 15.6743696,67.8981818 C15.0410435,70.2636364 13.7581522,73.5872727 11.1653043,77.3363636 L9.31765217,80 L12.5456304,80 C23.7109348,80 30.1741087,72.6636364 31.1737174,71.4836364 C34.5009348,72.2727273 37.9201739,72.6981818 41.5,72.6981818 C64.3574783,72.6981818 83,56.5545455 83,36.3490909 C83,16.1436364 64.3646957,0 41.5,0 Z"
                    id="Stroke-1"
                    stroke="#000000"
                    strokeWidth="2"
                  ></path>
                  <g
                    id="03_Icons/Functional/icon-clear"
                    transform="translate(22.739726, 17.142857)"
                    fillRule="evenodd"
                    strokeWidth="1"
                  >
                    <g id="Icon-/-icon-clear">
                      <polygon
                        points="0 0 36.3835616 0 36.3835616 36.5714286 0 36.5714286"
                      ></polygon>
                      <mask id="mask-2" fill="white">
                        <use href="#path-1"></use>
                      </mask>
                      <use
                        fill="#000000"
                        fillRule="nonzero"
                        href="#path-1"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FailureIcon;
